export default __webpack_public_path__ + "static/media/RBKothari.2e221192.png";